module.exports = __webpack_public_path__ + "static/media/021-school.2128b5d1.svg";